var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 54,
    viewBox: "0 0 62 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34887_14391)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.5059 1.36587C49.8916 2.63559 50.1422 4.62967 50.1422 4.62967C50.1422 4.62967 48.1434 4.56307 46.7578 3.29335C45.3721 2.02363 45.1215 0.029541 45.1215 0.029541C45.1215 0.029541 47.1203 0.0961493 48.5059 1.36587Z",
    fill: "url(#paint0_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7585 48.1852C37.5655 49.7235 37.493 51.5406 37.5096 51.5469C37.5054 51.5698 40.0137 50.8641 41.1384 49.1677C42.2651 47.4921 41.7162 45.7561 41.7328 45.7603C41.7266 45.7769 39.9495 46.6616 38.7585 48.1852Z",
    fill: "url(#paint1_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5151 53.5137C38.3134 53.139 37.4911 51.4655 37.4932 51.48C37.5201 51.4884 39.8792 50.8036 41.9111 51.045C43.9637 51.2969 45.1712 52.577 45.1712 52.5916C45.2002 52.5978 42.7417 53.8988 40.5151 53.5158V53.5137Z",
    fill: "url(#paint2_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1104 46.2618C42.2902 47.9499 42.5843 49.713 42.5988 49.7171C42.5988 49.74 44.8026 48.641 45.5441 46.8093C46.2897 44.9983 45.4405 43.4102 45.4571 43.4143C45.4529 43.431 43.9306 44.5904 43.1083 46.2639L43.1104 46.2618Z",
    fill: "url(#paint3_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7988 51.1121C43.6592 51.1184 42.5698 49.6405 42.5718 49.6551C42.5967 49.6593 44.6638 48.6039 46.6377 48.4915C48.6302 48.3854 50.0262 49.4199 50.0283 49.4324C50.0552 49.4324 47.9633 51.1101 45.7988 51.1121Z",
    fill: "url(#paint4_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8696 43.6644C46.4036 45.4378 47.0249 47.0926 47.0374 47.0926C47.0374 47.1155 48.9263 45.6772 49.3054 43.7726C49.6865 41.8889 48.5846 40.4963 48.5991 40.4963C48.5991 40.513 47.3377 41.9034 46.8696 43.6644Z",
    fill: "url(#paint5_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3492 47.8963C48.307 48.2689 46.9939 47.0241 46.998 47.0387C47.0208 47.0387 48.7855 45.6649 50.6641 45.2153C52.5613 44.7699 54.1002 45.5296 54.1023 45.5421C54.1272 45.54 52.4143 47.5258 50.3492 47.8963Z",
    fill: "url(#paint6_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0054 40.4935C49.875 42.2961 50.778 43.7927 50.7904 43.7906C50.7946 43.8135 52.3521 42.0921 52.3853 40.1751C52.4246 38.2788 51.1094 37.1132 51.1218 37.1111C51.1218 37.1277 50.138 38.7034 50.0054 40.4935Z",
    fill: "url(#paint7_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1355 43.9947C52.2258 44.7107 50.7387 43.7303 50.7428 43.7428C50.7635 43.7386 52.2154 42.1026 53.9615 41.3366C55.7241 40.5727 57.3583 41.0389 57.3625 41.0514C57.3852 41.0452 56.0638 43.2765 54.1355 43.9947Z",
    fill: "url(#paint8_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4951 36.8599C52.6794 38.6395 53.8228 39.9342 53.8352 39.9301C53.8414 39.9509 55.0593 38.0026 54.7652 36.1272C54.4793 34.2705 52.9984 33.365 53.0108 33.3608C53.015 33.3775 52.317 35.0927 52.4951 36.8578V36.8599Z",
    fill: "url(#paint9_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1264 39.5429C55.3886 40.5753 53.771 39.8822 53.7793 39.8947C53.7979 39.8884 54.9247 38.0401 56.5009 36.9847C58.0936 35.9252 59.7713 36.0918 59.7775 36.1022C59.7983 36.0918 58.8828 38.5042 57.1264 39.5429Z",
    fill: "url(#paint10_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3095 32.8714C54.788 34.5782 56.126 35.6377 56.1363 35.6336C56.1446 35.6544 57.0062 33.5354 56.4077 31.7495C55.8194 29.9802 54.2204 29.3578 54.2308 29.3516C54.237 29.3682 53.8373 31.177 54.3074 32.8714H54.3095Z",
    fill: "url(#paint11_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2929 34.6674C57.7664 35.985 56.068 35.5958 56.0763 35.6062C56.0928 35.5958 56.882 33.5934 58.2511 32.2758C59.6346 30.954 61.3061 30.8146 61.3144 30.825C61.333 30.8125 60.8359 33.3415 59.2908 34.6674H59.2929Z",
    fill: "url(#paint12_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4238 28.6374C56.1757 30.2277 57.6608 31.027 57.6711 31.0187C57.6835 31.0374 58.1765 28.8039 57.2941 27.1554C56.4242 25.5193 54.7528 25.1946 54.7631 25.1863C54.7735 25.2008 54.6823 27.0576 55.4238 28.6374Z",
    fill: "url(#paint13_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.604 29.503C59.3281 31.0724 57.5986 30.9933 57.609 31.0017C57.6235 30.9892 58.0647 28.8827 59.1873 27.3382C60.3244 25.7875 61.9358 25.3462 61.9461 25.3566C61.9627 25.34 61.8964 27.9231 60.6019 29.503H60.604Z",
    fill: "url(#paint14_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8132 24.2651C56.8156 25.6993 58.4022 26.2176 58.4126 26.2093C58.4271 26.2259 58.5389 23.9362 57.3956 22.4625C56.2668 21.0013 54.5746 20.9763 54.5829 20.968C54.5953 20.9805 54.8252 22.8393 55.8132 24.2651Z",
    fill: "url(#paint15_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0285 24.1837C60.0406 25.9613 58.3359 26.1944 58.3463 26.2028C58.3587 26.1882 58.4416 24.0317 59.2784 22.2999C60.1276 20.5598 61.6271 19.8313 61.6396 19.8375C61.6541 19.8188 62.0331 22.3915 61.0285 24.1816V24.1837Z",
    fill: "url(#paint16_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4487 19.8624C56.679 21.1071 58.3194 21.3319 58.3256 21.3215C58.3443 21.3361 58.0605 19.0464 56.679 17.7829C55.314 16.5299 53.6508 16.8088 53.6571 16.7984C53.6736 16.8088 54.2329 18.6239 55.4487 19.8624Z",
    fill: "url(#paint17_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5377 18.8404C59.8811 20.7845 58.249 21.3215 58.2614 21.3278C58.2718 21.3132 57.9839 19.1609 58.4934 17.2834C59.0133 15.3976 60.3471 14.4005 60.3616 14.4047C60.3741 14.3839 61.2108 16.8796 60.5377 18.8383V18.8404Z",
    fill: "url(#paint18_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3033 15.5393C55.7366 16.5634 57.3791 16.4906 57.3853 16.4802C57.406 16.4927 56.7163 14.2592 55.1193 13.2393C53.5411 12.2277 51.9586 12.8001 51.9649 12.7876C51.9835 12.7959 52.8866 14.5215 54.3033 15.5393Z",
    fill: "url(#paint19_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0982 13.6073C58.8123 15.6659 57.3086 16.4943 57.3231 16.4985C57.3293 16.4818 56.6624 14.3878 56.8032 12.4166C56.9544 10.435 58.0646 9.19446 58.0791 9.19862C58.0895 9.17781 59.3964 11.532 59.0961 13.6093L59.0982 13.6073Z",
    fill: "url(#paint20_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3501 11.4068C53.9615 12.1832 55.5564 11.8169 55.5626 11.8065C55.5874 11.8148 54.4752 9.69582 52.6877 8.94648C50.923 8.2013 49.4732 9.05264 49.4794 9.04015C49.5022 9.04639 50.7573 10.6346 52.3501 11.4089V11.4068Z",
    fill: "url(#paint21_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6831 8.61555C56.8115 10.7366 55.4922 11.8315 55.5087 11.8336C55.5129 11.8169 54.4524 9.83323 54.1832 7.81833C53.9222 5.79302 54.7527 4.34429 54.7693 4.34637C54.7776 4.32348 56.5671 6.47576 56.6831 8.61346V8.61555Z",
    fill: "url(#paint22_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5664 7.5752C51.3311 8.08309 52.8265 7.43366 52.8306 7.42117C52.8576 7.42533 51.3124 5.47912 49.3613 5.02119C47.433 4.56326 46.1737 5.67062 46.1758 5.65813C46.2006 5.66021 47.8224 7.06523 49.5664 7.5752Z",
    fill: "url(#paint23_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2573 4.00295C53.8414 6.12608 52.7623 7.46033 52.7809 7.46033C52.783 7.44368 51.3166 5.62236 50.5958 3.62411C49.8812 1.61338 50.3721 0.000206578 50.3907 0.000206578C50.3969 -0.02269 52.6815 1.86107 53.2573 4.00295Z",
    fill: "url(#paint24_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.451 52.105L30.4862 51.7157C33.6945 52.0072 36.8925 51.6491 39.9931 50.6479C43.013 49.6738 45.8091 48.1356 48.3029 46.0749C53.4789 41.7994 56.8177 35.7006 57.7021 28.8983C58.4271 23.3281 58.0543 18.3658 56.5961 14.1466C55.0303 9.61516 52.2424 6.07036 48.3071 3.61001L48.5121 3.27905C52.5241 5.78935 55.3658 9.40285 56.9627 14.0196C58.4416 18.2971 58.8185 23.3198 58.0853 28.9503C57.1864 35.8505 53.8 42.0409 48.5473 46.3788C46.0142 48.4707 43.1766 50.0318 40.1091 51.0226C36.9588 52.0384 33.709 52.4047 30.4489 52.1071L30.451 52.105Z",
    fill: "url(#paint25_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4462 1.36587C12.0606 2.63559 11.8099 4.62967 11.8099 4.62967C11.8099 4.62967 13.8087 4.56307 15.1943 3.29335C16.58 2.02363 16.8306 0.029541 16.8306 0.029541C16.8306 0.029541 14.8319 0.0961493 13.4462 1.36587Z",
    fill: "url(#paint26_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1934 48.1852C24.3864 49.7235 24.4589 51.5406 24.4424 51.5469C24.4465 51.5698 21.9382 50.8641 20.8136 49.1677C19.6868 47.4921 20.2357 45.7561 20.2191 45.7603C20.2253 45.7769 22.0025 46.6616 23.1934 48.1852Z",
    fill: "url(#paint27_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.437 53.5137C23.6387 53.139 24.461 51.4655 24.4589 51.48C24.432 51.4884 22.0729 50.8036 20.041 51.045C17.9884 51.2969 16.7809 52.577 16.7809 52.5916C16.7519 52.5978 19.2104 53.8988 21.437 53.5158V53.5137Z",
    fill: "url(#paint28_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8397 46.2618C19.66 47.9499 19.3658 49.713 19.3493 49.7171C19.3493 49.74 17.1455 48.641 16.404 46.8093C15.6583 44.9983 16.5075 43.4102 16.491 43.4143C16.4951 43.431 18.0175 44.5904 18.8397 46.2639V46.2618Z",
    fill: "url(#paint29_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1513 51.1121C18.2909 51.1184 19.3803 49.6405 19.3783 49.6551C19.3534 49.6593 17.2863 48.6039 15.3124 48.4915C13.3199 48.3854 11.9239 49.4199 11.9218 49.4324C11.8949 49.4324 13.9868 51.1101 16.1513 51.1121Z",
    fill: "url(#paint30_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0825 43.6644C15.5485 45.4378 14.9271 47.0926 14.9147 47.0926C14.9147 47.1155 13.0258 45.6772 12.6467 43.7726C12.2656 41.8889 13.3675 40.4963 13.353 40.4963C13.353 40.513 14.6144 41.9034 15.0825 43.6644Z",
    fill: "url(#paint31_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6007 47.8963C13.643 48.2689 14.9561 47.0241 14.952 47.0387C14.9292 47.0387 13.1645 45.6649 11.2859 45.2153C9.38867 44.7699 7.84975 45.5296 7.84768 45.5421C7.82282 45.54 9.53573 47.5258 11.6007 47.8963Z",
    fill: "url(#paint32_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9466 40.4935C12.0771 42.2961 11.1741 43.7927 11.1616 43.7906C11.1575 43.8135 9.59992 42.0921 9.56678 40.1751C9.52743 38.2788 10.8427 37.1132 10.8302 37.1111C10.8302 37.1277 11.8141 38.7034 11.9466 40.4935Z",
    fill: "url(#paint33_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.81455 43.9947C9.72422 44.7107 11.2114 43.7303 11.2072 43.7428C11.1865 43.7386 9.73458 42.1026 7.98853 41.3366C6.22591 40.5727 4.59171 41.0389 4.58757 41.0514C4.56479 41.0452 5.88623 43.2765 7.81455 43.9947Z",
    fill: "url(#paint34_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.457 36.8599C9.27266 38.6395 8.12934 39.9342 8.11691 39.9301C8.1107 39.9509 6.89282 38.0026 7.18693 36.1272C7.47276 34.2705 8.95369 33.365 8.94126 33.3608C8.93712 33.3775 9.63512 35.0927 9.457 36.8578V36.8599Z",
    fill: "url(#paint35_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8237 39.5429C6.56146 40.5753 8.17909 39.8822 8.1708 39.8947C8.15216 39.8884 7.02541 38.0401 5.44921 36.9847C3.85643 35.9252 2.17874 36.0918 2.17252 36.1022C2.15181 36.0918 3.0673 38.5042 4.8237 39.5429Z",
    fill: "url(#paint36_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.64261 32.8714C7.16415 34.5782 5.82614 35.6377 5.81578 35.6336C5.8075 35.6544 4.94587 33.5354 5.54445 31.7495C6.13268 29.9802 7.73167 29.3578 7.72131 29.3516C7.7151 29.3682 8.11485 31.177 7.64468 32.8714H7.64261Z",
    fill: "url(#paint37_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.65715 34.6674C4.18365 35.985 5.88206 35.5958 5.87377 35.6062C5.8572 35.5958 5.06806 33.5934 3.69898 32.2758C2.3154 30.954 0.643919 30.8146 0.635634 30.825C0.616993 30.8125 1.11409 33.3415 2.65922 34.6674H2.65715Z",
    fill: "url(#paint38_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.52625 28.6374C5.77439 30.2277 4.28932 31.027 4.27896 31.0187C4.26654 31.0374 3.77358 28.8039 4.65593 27.1554C5.52584 25.5193 7.19733 25.1946 7.18697 25.1863C7.17661 25.2008 7.26775 27.0576 6.52625 28.6374Z",
    fill: "url(#paint39_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.3461 29.5029C2.62198 31.0724 4.35145 30.9933 4.3411 31.0016C4.3266 30.9891 3.88543 28.8826 2.76282 27.3382C1.62571 25.7895 0.0142982 25.3482 0.00187082 25.3566C-0.014699 25.3399 0.0515802 27.9231 1.3461 29.5029Z",
    fill: "url(#paint40_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.13893 24.2651C5.13645 25.6993 3.54989 26.2176 3.54161 26.2093C3.52711 26.2259 3.41526 23.9362 4.55858 22.4625C5.6874 21.0013 7.37959 20.9763 7.37131 20.968C7.35888 20.9805 7.12897 22.8393 6.141 24.2651H6.13893Z",
    fill: "url(#paint41_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.921496 24.1837C1.90947 25.9613 3.61409 26.1944 3.60374 26.2028C3.59131 26.1882 3.50846 24.0317 2.67168 22.2999C1.82248 20.5598 0.322911 19.8313 0.310483 19.8375C0.295985 19.8188 -0.0830502 22.3915 0.921496 24.1816V24.1837Z",
    fill: "url(#paint42_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.50345 19.8624C5.27314 21.1071 3.63272 21.3319 3.62651 21.3215C3.60787 21.3361 3.89163 19.0464 5.27314 17.7829C6.63808 16.5299 8.30128 16.8088 8.29506 16.7984C8.27849 16.8088 7.71926 18.6239 6.50552 19.8624H6.50345Z",
    fill: "url(#paint43_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.41442 18.8404C2.071 20.7845 3.70313 21.3215 3.6907 21.3278C3.68035 21.3132 3.96825 19.1609 3.45873 17.2834C2.93885 15.3976 1.60498 14.4005 1.59048 14.4047C1.57805 14.3839 0.741273 16.8796 1.41442 18.8383V18.8404Z",
    fill: "url(#paint44_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.64885 15.5393C6.21556 16.5634 4.57307 16.4906 4.56686 16.4802C4.54615 16.4927 5.23587 14.2592 6.83278 13.2393C8.41106 12.2277 9.99348 12.8001 9.98727 12.7876C9.96862 12.7959 9.06557 14.5215 7.64885 15.5393Z",
    fill: "url(#paint45_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.85189 13.6073C3.13772 15.6659 4.64143 16.4943 4.62694 16.4985C4.62072 16.4818 5.28766 14.3878 5.14681 12.4166C4.99561 10.435 3.88543 9.19446 3.87094 9.19862C3.86058 9.17781 2.55363 11.532 2.85396 13.6093L2.85189 13.6073Z",
    fill: "url(#paint46_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.59997 11.4068C7.98855 12.1832 6.39371 11.8169 6.38749 11.8065C6.36264 11.8148 7.47489 9.69582 9.26236 8.94648C11.027 8.2013 12.4769 9.05264 12.4707 9.04015C12.4479 9.04639 11.1927 10.6346 9.59997 11.4089V11.4068Z",
    fill: "url(#paint47_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.269 8.61555C5.14058 10.7366 6.45995 11.8315 6.44338 11.8336C6.43924 11.8169 7.49971 9.83323 7.76897 7.81833C8.02994 5.79302 7.19938 4.34429 7.18281 4.34637C7.17453 4.32348 5.38498 6.47576 5.269 8.61346V8.61555Z",
    fill: "url(#paint48_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3858 7.5752C10.6211 8.08309 9.12564 7.43366 9.1215 7.42117C9.09458 7.42533 10.6397 5.47912 12.5908 5.02119C14.5191 4.56326 15.7784 5.67062 15.7764 5.65813C15.7515 5.66021 14.1297 7.06523 12.3858 7.5752Z",
    fill: "url(#paint49_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.69277 4.00295C8.10868 6.12608 9.18779 7.46033 9.16915 7.46033C9.16708 7.44368 10.6314 5.62236 11.3543 3.62411C12.0709 1.61338 11.578 0.000206578 11.5593 0.000206578C11.5531 -0.02269 9.26857 1.86107 8.69277 4.00295Z",
    fill: "url(#paint50_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4991 52.105L31.4638 51.7157C28.2555 52.0072 25.0575 51.6491 21.9569 50.6479C18.937 49.6738 16.1409 48.1356 13.6471 46.0749C8.47112 41.7994 5.1323 35.7006 4.24788 28.8983C3.52295 23.3281 3.89578 18.3658 5.35392 14.1466C6.91977 9.61516 9.70765 6.07036 13.643 3.61001L13.4379 3.27905C9.42596 5.78935 6.58423 9.40285 4.98731 14.0196C3.50846 18.2971 3.13149 23.3198 3.86471 28.9503C4.76362 35.8505 8.15008 42.0409 13.4027 46.3788C15.9358 48.4707 18.7734 50.0318 21.8409 51.0226C24.9912 52.0384 28.241 52.4047 31.5011 52.1071L31.4991 52.105Z",
    fill: "url(#paint51_linear_34887_14391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2515 10.5857H22.4545C21.8516 10.5857 21.3629 11.0769 21.3629 11.6827V11.9182C21.3629 12.5241 21.8516 13.0152 22.4545 13.0152H38.2515C38.8544 13.0152 39.3431 12.5241 39.3431 11.9182V11.6827C39.3431 11.0769 38.8544 10.5857 38.2515 10.5857Z",
    fill: "#F6E895"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5108 37.2065H38.2083C39.3208 37.2065 40.224 38.1142 40.224 39.2322H20.4938C20.4938 38.1142 21.3969 37.2065 22.5095 37.2065H22.5108Z",
    fill: "#F6E895"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6312 14.0334H24.0671V35.6176H27.6312V14.0334Z",
    fill: "#F6E895"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2215 14.0334H28.6573V35.6176H32.2215V14.0334Z",
    fill: "#F6E895"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8104 14.0334H33.2463V35.6176H36.8104V14.0334Z",
    fill: "#F6E895"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1337 18.8083C43.1337 18.8083 43.1414 18.8187 43.1557 18.8369C43.1544 18.8135 43.1337 18.8083 43.1337 18.8083Z",
    fill: "#F6E895"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1559 18.8387C43.1625 18.9229 42.9295 19.2307 40.6101 20.2699C37.6521 21.5971 37.6364 23.4097 37.6364 23.4097V31.3862C37.6364 31.3862 39.9858 26.906 41.3431 23.5609C41.3431 23.5609 39.8811 29.1947 39.69 29.4697C39.69 29.4697 41.0643 29.3237 43.101 27.6518C43.101 27.6518 41.7607 29.6485 39.5866 30.1195C39.5866 30.1195 38.1939 33.4632 37.6377 34.3076V35.4665C39.6926 34.7785 44.0538 31.302 44.4884 26.1799C44.8941 21.3932 43.3601 19.1149 43.1572 18.8374L43.1559 18.8387Z",
    fill: "#F6E895"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8719 18.8083C17.8719 18.8083 17.8641 18.8187 17.8499 18.8369C17.8511 18.8135 17.8719 18.8083 17.8719 18.8083Z",
    fill: "#F6E895"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8499 18.8387C17.8433 18.9229 18.0763 19.2307 20.3956 20.2699C23.3537 21.5971 23.3694 23.4097 23.3694 23.4097V31.3862C23.3694 31.3862 21.02 26.906 19.6627 23.5609C19.6627 23.5609 21.1247 29.1947 21.3158 29.4697C21.3158 29.4697 19.9415 29.3237 17.9048 27.6518C17.9048 27.6518 19.2451 29.6485 21.4192 30.1195C21.4192 30.1195 22.8119 33.4632 23.3681 34.3076V35.4665C21.3132 34.7785 16.952 31.302 16.5174 26.1799C16.1117 21.3932 17.6457 19.1149 17.8485 18.8374L17.8499 18.8387Z",
    fill: "#F6E895"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8865 50.4397L29.5238 52.2208L31.8865 54.0001L34.2476 52.2208L31.8865 50.4397Z",
    fill: "url(#paint52_linear_34887_14391)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_34887_14391",
    x1: 45.1215,
    y1: 2.32961,
    x2: 50.1401,
    y2: 2.32961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_34887_14391",
    x1: 37.5075,
    y1: 48.6536,
    x2: 41.8509,
    y2: 48.6536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_34887_14391",
    x1: 37.4932,
    y1: 52.2877,
    x2: 45.1712,
    y2: 52.2877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_34887_14391",
    x1: 42.5366,
    y1: 46.5657,
    x2: 45.8527,
    y2: 46.5657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_34887_14391",
    x1: 42.5718,
    y1: 49.7987,
    x2: 50.0283,
    y2: 49.7987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_34887_14391",
    x1: 46.6956,
    y1: 43.7955,
    x2: 49.3841,
    y2: 43.7955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_34887_14391",
    x1: 46.998,
    y1: 46.5204,
    x2: 54.1023,
    y2: 46.5204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_34887_14391",
    x1: 49.993,
    y1: 40.4498,
    x2: 52.3874,
    y2: 40.4498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_34887_14391",
    x1: 50.7428,
    y1: 42.5772,
    x2: 57.3645,
    y2: 42.5772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_34887_14391",
    x1: 52.4661,
    y1: 36.6475,
    x2: 54.8087,
    y2: 36.6475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_34887_14391",
    x1: 53.7793,
    y1: 38.0983,
    x2: 59.7796,
    y2: 38.0983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_34887_14391",
    x1: 54.0796,
    y1: 32.4926,
    x2: 56.621,
    y2: 32.4926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_34887_14391",
    x1: 56.0783,
    y1: 33.2374,
    x2: 61.3165,
    y2: 33.2374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_34887_14391",
    x1: 54.7652,
    y1: 28.1025,
    x2: 57.8202,
    y2: 28.1025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_34887_14391",
    x1: 57.609,
    y1: 28.1791,
    x2: 61.9503,
    y2: 28.1791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_34887_14391",
    x1: 54.5808,
    y1: 23.5866,
    x2: 58.4208,
    y2: 23.5866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_34887_14391",
    x1: 58.3463,
    y1: 23.0222,
    x2: 61.7224,
    y2: 23.0222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_34887_14391",
    x1: 53.6571,
    y1: 19.0506,
    x2: 58.3256,
    y2: 19.0506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_34887_14391",
    x1: 58.1889,
    y1: 17.8683,
    x2: 60.7987,
    y2: 17.8683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_34887_14391",
    x1: 51.9649,
    y1: 14.561,
    x2: 57.3853,
    y2: 14.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_34887_14391",
    x1: 56.7846,
    y1: 12.8475,
    x2: 59.1437,
    y2: 12.8475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_34887_14391",
    x1: 49.4794,
    y1: 10.2703,
    x2: 55.5626,
    y2: 10.2703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_34887_14391",
    x1: 54.1314,
    y1: 8.09101,
    x2: 56.6914,
    y2: 8.09101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_34887_14391",
    x1: 46.1758,
    y1: 6.33878,
    x2: 52.8306,
    y2: 6.33878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_34887_14391",
    x1: 50.2085,
    y1: 3.73027,
    x2: 53.4313,
    y2: 3.73027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_34887_14391",
    x1: 30.451,
    y1: 27.7409,
    x2: 58.4519,
    y2: 27.7409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_34887_14391",
    x1: 11.8099,
    y1: 0.000399932,
    x2: 16.8306,
    y2: 0.000399932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_34887_14391",
    x1: 20.099,
    y1: 48.6536,
    x2: 24.4444,
    y2: 48.6536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_34887_14391",
    x1: 16.7809,
    y1: 52.2877,
    x2: 24.4589,
    y2: 52.2877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_34887_14391",
    x1: 16.0995,
    y1: 46.5657,
    x2: 19.4155,
    y2: 46.5657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_34887_14391",
    x1: 11.9218,
    y1: 49.7987,
    x2: 19.3803,
    y2: 49.7987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_34887_14391",
    x1: 12.5659,
    y1: 43.7955,
    x2: 15.2565,
    y2: 43.7955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_34887_14391",
    x1: 7.84768,
    y1: 46.5204,
    x2: 14.9541,
    y2: 46.5204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_34887_14391",
    x1: 9.56471,
    y1: 40.4498,
    x2: 11.9591,
    y2: 40.4498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_34887_14391",
    x1: 4.58757,
    y1: 42.5772,
    x2: 11.2072,
    y2: 42.5772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_34887_14391",
    x1: 7.14136,
    y1: 36.6475,
    x2: 9.48599,
    y2: 36.6475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_34887_14391",
    x1: 2.17252,
    y1: 38.0983,
    x2: 8.17287,
    y2: 38.0983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_34887_14391",
    x1: 5.33112,
    y1: 32.4926,
    x2: 7.87044,
    y2: 32.4926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_34887_14391",
    x1: 0.633563,
    y1: 33.2374,
    x2: 5.87377,
    y2: 33.2374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_34887_14391",
    x1: 4.12984,
    y1: 28.1025,
    x2: 7.18697,
    y2: 28.1025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_34887_14391",
    x1: 0.00187082,
    y1: 28.1791,
    x2: 4.3411,
    y2: 28.1791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_34887_14391",
    x1: 3.53125,
    y1: 23.5866,
    x2: 7.36924,
    y2: 23.5866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_34887_14391",
    x1: 0.229705,
    y1: 23.0222,
    x2: 3.60374,
    y2: 23.0222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_34887_14391",
    x1: 3.62651,
    y1: 19.0506,
    x2: 8.29506,
    y2: 19.0506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_34887_14391",
    x1: 1.15345,
    y1: 17.8683,
    x2: 3.76113,
    y2: 17.8683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_34887_14391",
    x1: 4.56479,
    y1: 14.561,
    x2: 9.98519,
    y2: 14.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_34887_14391",
    x1: 2.8084,
    y1: 12.8475,
    x2: 5.16545,
    y2: 12.8475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_34887_14391",
    x1: 6.38749,
    y1: 10.2703,
    x2: 12.4707,
    y2: 10.2703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_34887_14391",
    x1: 5.26071,
    y1: 8.09101,
    x2: 7.82075,
    y2: 8.09101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_34887_14391",
    x1: 9.1215,
    y1: 6.33878,
    x2: 15.7764,
    y2: 6.33878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_34887_14391",
    x1: 8.52085,
    y1: 3.73027,
    x2: 11.7416,
    y2: 3.73027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_34887_14391",
    x1: 3.50017,
    y1: 27.7409,
    x2: 31.4991,
    y2: 27.7409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_34887_14391",
    x1: 29.5238,
    y1: 52.2208,
    x2: 34.2476,
    y2: 52.2208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34887_14391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremium);
export default __webpack_public_path__ + "static/media/premium.807ed27593a50440346146a08685eb02.svg";
export { ForwardRef as ReactComponent };